import { useState, useCallback } from 'react';

export const useCollapseState = (allSections, expandedSections) => {
  const [activeSections, setActiveSections] = useState(expandedSections);

  const flipExpandAllState = useCallback(() => {
    if (activeSections.length) {
      setActiveSections([]);
    } else {
      setActiveSections(allSections);
    }
  }, [activeSections.length, allSections]);

  const expandAll = useCallback(() => {
    setActiveSections(allSections);
  }, [allSections]);

  return [allSections, activeSections, setActiveSections, flipExpandAllState, expandAll];
};
